import * as React from "react";
const SvgFiRrEnvelopeOpenText = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-envelope-open-text_svg__a)">
      <path
        fill="#062147"
        d="M7 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m1 5h6a1 1 0 1 0 0-2H8a1 1 0 0 0 0 2m16 1.708V19c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5v-6.292c0-1.356.562-2.673 1.541-3.611L3 7.699V4c0-2.206 1.794-4 4-4h10c2.206 0 4 1.794 4 4v3.699l1.459 1.397A5.03 5.03 0 0 1 24 12.707zM5 4v8.243l4.878 4.879c1.134 1.133 3.11 1.133 4.243 0L19 12.243V4c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2m17 8.708q0-.293-.058-.579l-6.407 6.407A4.97 4.97 0 0 1 12 20a4.97 4.97 0 0 1-3.536-1.464l-6.406-6.408Q2 12.414 2 12.707v6.292c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-envelope-open-text_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEnvelopeOpenText;
